import { Step } from 'react-joyride';

export const clientTourSteps: Step[] = [
  {
    target: '[data-tour="client-home"]',
    title: 'Welcome to Your Dashboard',
    content: 'This is your homepage where you can view system notifications and important messages from practitioners.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="client-profile"]',
    title: 'Your Profile',
    content: 'Fill in your personal information and preferences here. Set your timezone first to avoid appointment time mistakes.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-calendar"]',
    title: 'Calendar View',
    content: 'View all your appointments in a calendar overview. Easily see your schedule at a glance.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-upcoming"]',
    title: 'Upcoming Appointments',
    content: 'Check and manage your upcoming healing sessions. You can message practitioners and view session details here.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-ai-navigator"]',
    title: 'AI Navigator (Reso)',
    content: 'Meet Reso, your personal AI wellness guide. Share how you feel and get personalized therapy recommendations, practitioner matches, and wellness insights.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-payment"]',
    title: 'Payment Methods',
    content: 'Add payment methods to book services. Your payment information is securely stored.',
    placement: 'right',
  },
  {
    target: '[data-tour="client-settings"]',
    title: 'Settings',
    content: 'Manage your account settings and notification preferences. You can also restart this guide anytime from here!',
    placement: 'right',
  },
];

export const practitionerTourSteps: Step[] = [
  {
    target: '[data-tour="practitioner-home"]',
    title: 'Welcome!',
    content: 'This is your dashboard homepage. View system messages, notifications, and important updates here.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="practitioner-profile"]',
    title: '1️⃣ Complete Your Profile',
    content: 'First step! Fill in your personal info, professional title, bio, location, and timezone so clients can find you.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-certifications"]',
    title: '2️⃣ Upload Certifications',
    content: 'Upload at least one valid certificate. The name on the certificate must match your profile. This is required before your services can go live.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-services"]',
    title: '3️⃣ Add Services',
    content: 'Add the healing services you offer with pricing and duration. Services will go live after your certification is approved.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-calendar"]',
    title: 'Calendar View',
    content: 'View and manage your appointment calendar. See all your bookings at a glance.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-upcoming"]',
    title: 'Upcoming Appointments',
    content: 'Manage your upcoming sessions. Confirm bookings, message clients, and prepare for sessions here.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-availability"]',
    title: 'Set Availability',
    content: 'Configure your available time slots for bookings. Set your working hours and days off.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-finances"]',
    title: '4️⃣ Set Up Payouts',
    content: 'Connect your Stripe account to receive client payments. This is required to accept bookings.',
    placement: 'right',
  },
  {
    target: '[data-tour="practitioner-settings"]',
    title: 'Settings',
    content: 'Manage account settings, notification preferences, and integrations. You can restart this guide anytime from here!',
    placement: 'right',
  },
];
